import React, { memo } from "react";

import { classNames } from "helpers";

import { getChannelBadge } from "../helpers";
import { ChannelTileProps } from "../types";

/** Kvadratić u boji oglasnika s početnim slovom naziva, umjesto logotipa. */
const ChannelTile: React.FC<ChannelTileProps> = ({ code, name }) => {
  const badge = getChannelBadge(code);

  return (
    <span
      className={classNames(
        "flex items-center justify-center w-7 h-7 rounded-md text-[0.7rem] font-bold flex-shrink-0",
        badge.bg,
        badge.text
      )}
    >
      {name.charAt(0).toUpperCase()}
    </span>
  );
};

export default memo(ChannelTile);
